import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

/**
 * Sliders icon — used as the "Display & Preferences" indicator in the
 * Profile page's left rail.
 */
export const Sliders = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fass', 'sliders']}
      {...props}
    />
  );
};
